package com.sweetlime.bingeamigo.state

import com.sweetlime.bingeamigo.model.LibraryMovie
import com.sweetlime.bingeamigo.model.UserActivity
import com.sweetlime.bingeamigo.model.UserProfile
import com.sweetlime.bingeamigo.model.WatchMovie

data class UserProfileUiState(

    val profile: UserProfile? = null,

    val watchlist: List<LibraryMovie> = emptyList(),
    val watched: List<LibraryMovie> = emptyList(),
    val favorites: List<LibraryMovie> = emptyList(),
    val activity: List<UserActivity> = emptyList(),

    val isFollowing: Boolean = false,

    val followersCount: Int = 0,

    val followingCount: Int = 0,

    val loading: Boolean = true
)